import React, { AnchorHTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';

/**
 * Anchor Description:
 * Generic anchor component that handles some of the same defaults
 * and best practices for external links
 *
 * @param {object} props - React Props
 * @param {string} props.className - custom classes
 * @param {boolean} props.hideExternalIcon - hide the external icon when isExternal is true
 * @param {string} props.href - string href value
 * @param {boolean} props.isExternal - will apply various enhancements for links pointing outside of the domain
 * @return {JSX}
 */

interface AnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  hideExternalIcon?: boolean;
  href?: string;
  isExternal?: boolean;
  fromFooter?: boolean;
  disabled?: boolean;
  children?: ReactNode;
}

const Anchor: React.FC<AnchorProps> = ({
  className,
  disabled,
  hideExternalIcon,
  href,
  isExternal,
  fromFooter,
  children,
  ...props
}) => (
  <a
    href={!disabled ? href : undefined}
    className={cn(className, { 'link--external': !fromFooter && isExternal && !hideExternalIcon, disabled })}
    rel={isExternal ? 'noopener noreferrer' : undefined}
    target={isExternal ? '_blank' : undefined}
    {...props}
  >
    {children}
  </a>
);

export default Anchor;
